@if (userId) {
    <div class="signature-panel ws-flex-container-vertical">
        <div class="signature-container">
            <ws-ace-card [header]="(isSignatureEditMode ? 'Create your ' : '') + 'Signature'" [hasActions]="true">
                <ng-container card-actions>
                    <div class="d-flex justify-content-between">
                        <div class="me-4">
                            @if (isSignatureEditMode) {
                                <ws-select
                                    [options]="signatureOptions"
                                    labelProperty="name"
                                    valueProperty="value"
                                    size="sm"
                                    [(ngModel)]="signatureType"
                                    (selectedOptionChanged)="signatureTypeChanged($event)"
                                >
                                </ws-select>
                            }
                        </div>
                        <div>
                            @if (isSignatureEditMode) {
                                <button
                                    title="Clear Signature"
                                    type="button"
                                    class="ace-btn btn-text has-icon btn-secondary"
                                    (click)="clearSignature()"
                                >
                                    <i class="fa fa-trash fa-align"></i>
                                </button>
                            }
                            @if (isSignatureEditMode) {
                                <button
                                    title="Save Signature"
                                    type="button"
                                    class="ace-btn btn-text has-icon btn-secondary"
                                    (click)="saveSignature()"
                                    [disabled]="!signatureChanged"
                                >
                                    <i class="fa fa-save fa-align"></i>
                                </button>
                            }
                            @if (isSignatureEditMode) {
                                <button
                                    title="Cancel"
                                    type="button"
                                    class="ace-btn btn-text has-icon btn-secondary btn-danger"
                                    (click)="cancelSignature()"
                                >
                                    <i class="fa fa-times fa-align"></i>
                                </button>
                            }
                            @if (canEditSignature && !isSignatureEditMode && !signatureLoading) {
                                <button
                                    type="button"
                                    class="ace-btn btn-text has-icon btn-secondary"
                                    (click)="beginSigEditMode()"
                                >
                                    <i class="fa fa-pencil"></i>
                                </button>
                            }
                        </div>
                    </div>
                </ng-container>
                <div class="signature-card-body" card-body>
                    @if (signatureLoading) {
                        <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
                    }
                    @if (!contactSignatureImage && !signatureLoading && !isSignatureEditMode) {
                        @if (canEditSignature) {
                            <div class="no-data-message no-signature-message">
                                <span (click)="beginSigEditMode()"
                                    >It doesn't look like you have a signature. Click edit to create one.</span
                                >
                                <span class="inline-text-button" (click)="beginSigEditMode()"
                                    ><i class="fa fa-pencil"></i
                                ></span>
                            </div>
                        } @else {
                            <div class="no-data-message">
                                <span>This user does not have a signature.</span>
                            </div>
                        }
                    }
                    @if (
                        signatureType === signatureTypes.Create &&
                        !signatureLoading &&
                        (contactSignatureImage || isSignatureEditMode)
                    ) {
                        <div class="signature-canvas" [class.editing]="isSignatureEditMode">
                            @if (contactSignatureImage || isSignatureEditMode) {
                                <div class="signing-line">
                                    <span class="sig-x">X</span>
                                    <div class="line">
                                        @if (isSignatureEditMode) {
                                            <span>Sign Above</span>
                                        }
                                    </div>
                                </div>
                            }
                            @if (isSignatureEditMode) {
                                <canvas #signatureCanvas width="600" height="200"></canvas>
                            }
                            @if (contactSignatureImage && !isSignatureEditMode) {
                                <img [attr.src]="contactSignatureImage" />
                            }
                        </div>
                    }
                    @if (
                        signatureType === signatureTypes.Upload &&
                        !signatureLoading &&
                        (contactSignatureImage || isSignatureEditMode)
                    ) {
                        <div class="signature-upload" [class.cropping]="imageFile && selectedFileType">
                            @if (!imageFile || !selectedFileType) {
                                <div class="mb-4 ws-stretch-width">
                                    <span>Upload Requirements</span>
                                    <ul>
                                        <li>File type must be *.gif or *.png</li>
                                        <li>Use a single color transparency</li>
                                        <li>Minimum 600 pixels wide by 200 pixels tall</li>
                                        <li>Signature centered horizontally and vertically</li>
                                    </ul>
                                    <label>Select a file:</label>
                                    <ws-file-picker (picked)="filePicked($event)" acceptTypes=".gif,.png">
                                    </ws-file-picker>
                                    @if (uploadTypeError) {
                                        <span style="color: var(--ace-danger)"
                                            >The image must be of type .gif or .png</span
                                        >
                                    }
                                </div>
                            }
                            <div
                                class="upload-canvas ws-flex-container-vertical ws-flex-align-items-center"
                                [class.editing]="imageFile && selectedFileType"
                            >
                                <image-cropper
                                    [imageFile]="imageFile"
                                    [maintainAspectRatio]="true"
                                    [containWithinAspectRatio]="true"
                                    [aspectRatio]="3 / 1"
                                    [resizeToWidth]="600"
                                    [cropperMinWidth]="128"
                                    [onlyScaleDown]="true"
                                    [canvasRotation]="canvasRotation"
                                    [transform]="transform"
                                    [alignImage]="'center'"
                                    [style.display]="imageFile && selectedFileType ? null : 'none'"
                                    format="png"
                                    output="base64"
                                    (imageCropped)="imageCropped($event)"
                                    (loadImageFailed)="loadImageFailed()"
                                >
                                </image-cropper>
                                @if (imageFile && selectedFileType) {
                                    <div class="ws-flex-container-horizontal ws-flex-justify-content-center">
                                        <button
                                            title="Rotate Left 90"
                                            type="button"
                                            class="ace-btn has-icon btn-primary"
                                            (click)="rotateImageLeft()"
                                        >
                                            <i class="fa fa-undo fa-align"></i>
                                        </button>
                                        <button
                                            title="Save Signature"
                                            type="button"
                                            class="ace-btn has-icon btn-primary"
                                            (click)="saveSignature()"
                                        >
                                            <i class="fa fa-save fa-align"></i>
                                        </button>
                                        <button
                                            title="Rotate Right 90"
                                            type="button"
                                            class="ace-btn has-icon btn-primary"
                                            (click)="rotateImageRight()"
                                        >
                                            <i class="fa fa-repeat fa-align"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>
            </ws-ace-card>
        </div>
        <div class="authorized-container">
            <ws-ace-card header="Users Authorized" [hasActions]="true">
                <ng-container card-actions>
                    <div class="float-end">
                        @if (isAuthorizedEditMode) {
                            <button
                                title="Add User"
                                type="button"
                                class="ace-btn btn-text has-icon btn-secondary"
                                (click)="addUser()"
                            >
                                <i class="fa fa-plus fa-align"></i>
                            </button>
                        }
                        @if (isAuthorizedEditMode) {
                            <button
                                title="Save Signature"
                                type="button"
                                class="ace-btn btn-text has-icon btn-secondary"
                                (click)="saveAuthorized()"
                                [disabled]="!authorizedUsersChanged"
                            >
                                <i class="fa fa-save fa-align"></i>
                            </button>
                        }
                        @if (isAuthorizedEditMode) {
                            <button
                                title="Cancel"
                                type="button"
                                class="ace-btn btn-text has-icon btn-secondary btn-danger"
                                (click)="cancelAuthorized()"
                            >
                                <i class="fa fa-times fa-align"></i>
                            </button>
                        }
                        @if (
                            contactSignatureImage &&
                            canEditAuthorized &&
                            !isAuthorizedEditMode &&
                            !usersAuthorizedLoading
                        ) {
                            <button
                                type="button"
                                class="ace-btn btn-text has-icon btn-secondary"
                                (click)="beginAuthEditMode()"
                            >
                                <i class="fa fa-pencil"></i>
                            </button>
                        }
                    </div>
                </ng-container>
                <div class="signature-card-body" card-body>
                    @if (usersAuthorizedLoading) {
                        <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
                    }
                    @if (!contactSignatureImage && !usersAuthorizedLoading) {
                        <div class="no-data-message no-signature-message">
                            <span (click)="beginSigEditMode()">A signature is required to add authorized users.</span>
                        </div>
                    }
                    @if (contactSignatureImage && !authorizedUsersChanges.length && !addNewPerson) {
                        <div class="no-data-message">
                            <span>There are no additional authorized users for this signature.</span>
                        </div>
                    }
                    @if (isAuthorizedEditMode && addNewPerson) {
                        <div class="ws-flex-container-horizontal ws-flex-align-self-center ws-flex-align-items-center">
                            <user-picker [search]="search" (contactChanged)="assignUser($event)"></user-picker>
                            <button
                                class="ace-btn btn-sm btn-primary"
                                (click)="saveUser()"
                                [disabled]="!(userToAdd && canAddUser)"
                            >
                                OK
                            </button>
                            <button class="ace-btn has-icon btn-sm btn-primary btn-danger" (click)="cancelAddUser()">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>
                    }
                    @if (contactSignatureImage && authorizedUsersChanges.length) {
                        <div>
                            <table class="table table-sm mb-0 caption-top">
                                <caption>Users who are granted authorization to apply the digital signature</caption>
                                <tbody>
                                    @for (user of authorizedUsersChanges; track user) {
                                        <tr>
                                            <td> {{ user.lastName }}, {{ user.firstName }} </td>
                                            <td style="width: 40px">
                                                @if (isAuthorizedEditMode) {
                                                    <button
                                                        class="ace-btn has-icon btn-primary btn-danger"
                                                        type="button"
                                                        (click)="removeUser(user)"
                                                        style="margin: 0px"
                                                    >
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                }
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </ws-ace-card>
        </div>
    </div>
}
